import { render, staticRenderFns } from "./DCNumberView.vue?vue&type=template&id=721a62fe&"
import script from "./DCNumberView.vue?vue&type=script&lang=js&"
export * from "./DCNumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports